/**
 * Payment type
 */
export enum PaymentType {
  Card = 'card',
  Bank = 'bank'
}

/**
 * Account type for bank payments
 */
export enum AccountType {
  Checking = 'checking',
  Savings = 'savings'
}

/**
 * Payment period for recurring payments
 */
export enum PaymentPeriod {
  OneTime = 'DA',
  Monthly = 'MO',
  Weekly = 'WE',
}

/**
 * Payment amount type for auto pay
 */
export enum PaymentAmountType {
  Regular = 'regular',
  Fixed = 'fixed'
}

/**
 * Payment form model
 */
export interface PaymentForm {
  existingBankId?: number;
  loanId?: string;
  amount: number | null;
  type: PaymentType;
  isRecurring: boolean;
  billRegularAmount: boolean;
  cardNumber?: string;
  cardExpiry?: string;
  cardCvv?: string;
  accountNumber?: string;
  accountType?: AccountType;
  routingNumber?: string;
  // Auto pay fields
  dateRange?: {
    start: Date | null;
    end: Date | null;
  };
  period?: PaymentPeriod;
  // Payment amount type for auto pay
  amountType?: PaymentAmountType;
}

/**
 * Payment response
 */
export interface PaymentResponse {
  success: boolean;
  transactionId?: string;
  error?: string;
}

/**
 * Payment form with required loanId and period for recurring payments
 */
export interface RecurringPaymentForm extends PaymentForm {
  loanId: string;
  period: PaymentPeriod;
}

/**
 * Payment status
 */
export enum PaymentStep {
  Initial = 'InitialStep',
  Review = 'Review',
  Confirmation = 'Confirmation',
  AddCreditCard = 'AddCreditCard'
}

/**
 * Recurring payment details for existing auto pay configurations
 */
export interface RecurringPaymentDetails {
  readonly id: number;
  readonly isActive: boolean;
  readonly paymentAmount: number | null;
  readonly billingType: 'billing' | 'recurring';
  readonly startDate: Date;
  readonly endDate: Date | null;
  readonly frequency: PaymentPeriod;
  readonly paymentMethod: PaymentType;
  readonly lastFourDigits?: string;
  readonly accountNumber?: string;
  readonly routingNumber?: string;
}
